

export enum ClaroEvents {
  UserLoggedIn = 'login',
  UserLoggedInViaToken = 'tokenLogin',
  Discovery = 'discovery',
  MakeMoov = 'makeMoov',
  TeamMemberReviewed = 'teamMemberReviewed',
  TeamMemberReviewedFromExternalLink = 'teamMemberReviewedFromExternalLink',
  IssueSelected = 'issueSelected',
  MoovViewed = 'moovViewed',
  ActiveMoovViewed = 'activeMoovViewed',
  ActiveMoovEnded = 'activeMoovEnded',
  ActiveMoovExtended = 'activeMoovExtended',
  ActiveMoovStepChecked = 'activeMoovStepChecked',
  ActiveMoovStepCommentSaved = 'activeMoovStepCommentSaved',
  ChallengeFlowClicked = 'challengeFlowClicked',
  WizardShowMoreMoovsSelected = 'wizardShowMoreMoovsSelected',
  TeamMemberInsightsReviewed = 'teamMemberInsightsReviewed',
  UserEngagementUnsubscribeEvent = 'userEngagementUnsubscribeEvent',
  RecommendedMoovReviewed = 'recommendedMoovReviewed',
  DiscoveryProcessStarted = 'discoveryProcessStarted',
  DiscoveryProcessResumed = 'discoveryProcessResumed',
  DiscoveryProcessCompleted = 'discoveryProcessCompleted',
  TeamMemberInsightsTabSelected = 'teamMemberInsightsTabSelected',
  TeamMemberMoovsTabSelected = 'teamMemberMoovsTabSelected',
  MoovFeedback = 'moovFeedback',
  UserResponsedToQuestioner = 'userResponsedToQuestioner',
  UserResponsedAgainToDriverGapQuestion = 'userResponsedAgainToDriverGapQuestion',
  UserEndedQuestioner = 'userEndedQuestioner',
  UserStartedRediscovery = 'userStartedRediscovery',
  UserEndedRediscovery = 'userEndedRediscovery',
  UserFailedToResponsedToQuestioner = 'userFailedToResponsedToQuestioner',
  UserMutedQuestionVideo = 'userMutedQuestionVideo',
  UserUnMutedQuestionVideo = 'userUnMutedQuestionVideo',
  UserMutedIntroVideo = 'userMutedIntroVideo',
  UserUnMutedIntroVideo = 'userUnMutedIntroVideo',
  TeamViewPage = 'teamViewPage',
  TeamMemberDetailedViewPage = 'teamMemberDetailedViewPage',
  MyMotivationsPage = 'myMotivationsPage',
  SpecificMotivationPage = 'specificMotivationPage',
  UserHitMoreInfoOnTips = 'userHitMoreInfoOnTips',
  UserRespondedToDriverGapQuestion = 'userRespondedToDriverGapQuestion',
  UserSelfRegistered = 'userSelfRegistered',
  TeamViewScopeChange = 'teamViewScopeChange',
  TeamViewLoadedWithScope = 'teamViewLoadedWithScope',
  MoovToSelf = 'userSelfMoov',
  UserUnsubscribed = 'userUnsubscribed',
  MM_EmergancyRechargeToSelf = 'MM_EmergancyRechargeToSelf',
  TMC_OpenTeamMemberDetails = 'TMC_openTeamMemberDetails',
  TMC_EmergancyRecharge = 'TMC_emergancyRecharge',
  TMC_RaiseEnergy = 'TMC_raiseEnergy',
  Conversational_chatOpened = 'Conversational_chatOpened',
  Conversational_userMessage = 'Conversational_userMessage',
  Conversational_userTextMessage = 'Conversational_userTextMessage',
  Conversational_userVoiceMessage = 'Conversational_userVoiceMessage',
  Conversational_serverMessage = 'Conversational_serverMessage',
  Conversational_newChatStarted = 'Conversational_newChatStarted',
  Conversational_messageLiked = 'Conversational_messageLiked',
  Conversational_messageDisliked = 'Conversational_messageDisliked',
  Conversational_structuredProcessChatOpened = 'Conversational_structuredProcessChatOpened',
  Conversational_structuredProcessChatMessage = 'Conversational_structuredProcessChatMessage',
  Conversational_structuredProcessChatMessageLiked = 'Conversational_structuredProcessChatMessageLiked',
  Conversational_structuredProcessChatMessageDisliked = 'Conversational_structuredProcessChatMessageDisliked',
  Conversational_structuredProcessChatMessageCompleted = 'Conversational_structuredProcessChatMessageCompleted',
  TeamStateDashboard_viewed = 'TeamStateDashboard_viewed',
  TeamStateDashboard_cultureSelected = 'TeamStateDashboard_cultureSelected',
  Conversational_externalQuestion = 'Conversational_externalQuestion',
  Conversational_externalQuestion_Text = 'Conversational_externalQuestion_Text',
  Conversational_externalInsight = 'Conversational_externalInisght',
  UserUploadedCV = 'UserUploadedCV',
  Conversational_chatDeleted = 'Conversational_chatDeleted',
  MicrosoftLogin_connect = 'MicrosoftLogin_connect',
  MicrosoftLogin_disconnect = 'MicrosoftLogin_disconnect',
  MicrosoftLogin_shareCalendar = 'MicrosoftLogin_shareCalendar',
  PulseCheck_viewed = 'PulseCheck_viewed',
  PulseCheck_submitted = 'PulseCheck_submitted',
  PulseCheck_pendingNotificationShown = 'PulseCheck_pendingNotificationShown',
  StructuredProcess_introViewed = 'StructuredProcess_introViewed',
  StructuredProcess_ProcessStarted = 'StructuredProcess_ProcessStarted',
  StructuredProcess_StepStatusIsCompleted = 'StructuredProcess_StepStatusIsCompleted',
  StructuredProcess_NextStepTriggered = 'StructuredProcess_NextStepTriggered',
  StructuredProcess_StepSelected = 'StructuredProcess_StepSelected',
  StructuredProcess_StepSkipped = 'StructuredProcess_ProcessStepSkipped',
  StructuredProcess_StepRestarted = 'StructuredProcess_StepRestarted',
  StructuredProcess_ProcessReset = 'StructuredProcess_ProcessReset',
  StructuredProcess_StepViewed = 'StructuredProcess_StepViewed',
  StructuredProcess_UserMessageSent = 'StructuredProcess_UserMessageSent',
  StructuredProcess_AssistantMessageReceived = 'StructuredProcess_AssistantMessageReceived',
 }
 
 
 export enum ClaroFlows {
  MakeRecommendedMoov = 'MakeRecommendedMoovFlow',
  SolveIssue = 'SolveIssueFlow',
 }
 